<template>
  <div class="option-list">
    <h3 v-if="title">{{ title }}</h3>
    <div class="options-grid" :style="gridStyle">
      <OptionListItem
        v-for="item in items"
        :key="item.value"
        v-bind="item"
        :selected="item.value === selected"
        @select="selectItem"
      />
    </div>
  </div>
</template>

<script>
import OptionListItem from './OptionListItem.vue';

export default {
  name: 'OptionList',
  model: { prop: 'selected', event: 'update:selected' },
  components: { OptionListItem },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected: [String, Number],
    title: String,
    perRow: {
      type: Number,
      default: 4
    },
    forceColumns: {
      type: Number,
      default: null
    }
  },
  emits: ['update:selected'],
  data() {
    return {
      windowWidth: 0
    }
  },
  computed: {
    currentColumns() {
      // If forceColumns is set, always use that value
      if (this.forceColumns) {
        return this.forceColumns;
      }

      const w = this.windowWidth
      const cap = (n) => Math.min(this.perRow || 4, n)
      if (w < 600) return 1
      if (w < 900) return cap(2)
      if (w < 1200) return cap(3)
      return cap(this.perRow || 4)
    },
    gridStyle() {
      return { gridTemplateColumns: `repeat(${this.currentColumns}, minmax(0, 1fr))` }
    }
  },
  mounted() {
    const setWidth = () => { this.windowWidth = window.innerWidth || 0 }
    this._setWidth = setWidth
    setWidth()
    window.addEventListener('resize', setWidth)
  },
  beforeDestroy() {
    if (this._setWidth) window.removeEventListener('resize', this._setWidth)
  },
  methods: {
    selectItem(value) {
      this.$emit('update:selected', value);
    }
  }
};
</script>

<style scoped>
.option-list {
  width: 100%;
}

.options-grid {
  display: grid;
  gap: 16px;
  margin-bottom: 32px;
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

/* The media queries remain as a non-JS fallback, but inline style will take precedence */
@media (min-width: 600px) {
  .options-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 900px) {
  .options-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1200px) {
  .options-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
